import { jsx, jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";
import { actions as loginActions } from "./login/loginActions";
import { actions as appActions } from "./appActions";
import { actions as customerVaultActions } from "./customerVault/customerVaultActions";
import * as iframeUtils from "./utils/iframeUtils";
import LoginPage from "./LoginPage";
import Terminal from "./Terminal";
import BasicResult from "./BasicResult";
import VtDisabledNotice from "./self/VtDisabledNotice";
export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInIframe: parent !== window,
      isLoaded: false,
      formUpdateCount: 0,
      formHeight: 0
    };
    this.autoFocus = this.autoFocus.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.formRef = React.createRef();
    this.autoFocusAttempts = 0;
  }
  componentDidMount() {
    if (this.props.simpleLoginKey) {
      this.props.simpleLogin(this.props.simpleLoginKey);
    } else {
      this.props.refresh();
    }
    this.props.setupListeners();
    setTimeout(this.autoFocus, 2e3);
  }
  componentDidUpdate() {
    if (!this.state.isLoaded && this.props.isMerchantListLoaded && this.props.isTerminalListLoaded) {
      this.setState({
        isLoaded: true
      });
      iframeUtils.postMessage("loaded");
      const { customerRef } = this.props;
      if (customerRef) {
        this.props.getCustomerCards(customerRef);
        this.props.getCustomerEchecks(customerRef);
      }
    }
    const formHeight = _.get(this.formRef, "current.scrollHeight");
    if (formHeight && formHeight !== this.state.formHeight) {
      this.setState(
        { formHeight },
        () => iframeUtils.postMessage("formHeightChange", { formHeight })
      );
    }
  }
  autoFocus() {
    this.autoFocusAttempts++;
    let found = false;
    try {
      const selectableElement = this.formRef.current.querySelector("select, input");
      if (selectableElement) {
        selectableElement.focus();
        found = true;
      }
    } catch {
    }
    if (!found && this.autoFocusAttempts < 20) {
      setTimeout(this.autoFocus, 250);
    }
  }
  handleFormChange() {
    this.setState({ formUpdateCount: this.state.formUpdateCount + 1 });
  }
  renderCss() {
    if (this.props.cssFile && /^https:.*\.css$/.test(this.props.cssFile)) {
      return /* @__PURE__ */ jsx("link", { rel: "stylesheet", type: "text/css", href: this.props.cssFile });
    }
  }
  render() {
    const classNames = [
      "nexio",
      "retailIframe",
      this.state.isInIframe ? "inIframe" : ""
    ].join(" ");
    if (!this.props.isLoggedIn) {
      return /* @__PURE__ */ jsx(LoginPage, { isInIframe: this.state.isInIframe, cssFile: this.props.cssFile });
    } else if (!this.props.isSelfLoaded) {
      return /* @__PURE__ */ jsx("div", { ref: this.formRef, className: classNames });
    } else if (!this.props.isEnabledForVTerm && !this.props.isApiUser) {
      return /* @__PURE__ */ jsxs("div", { ref: this.formRef, className: `${classNames} loaded`, children: [
        this.renderCss(),
        /* @__PURE__ */ jsx(VtDisabledNotice, {})
      ] });
    } else {
      const formClassNames = [
        classNames,
        this.state.isLoaded ? "loaded" : "loading"
      ].join(" ");
      return /* @__PURE__ */ jsxs("div", { ref: this.formRef, className: formClassNames, children: [
        this.renderCss(),
        this.props.isActionCompleted ? /* @__PURE__ */ jsx(BasicResult, { message: this.props.actionResult }) : /* @__PURE__ */ jsx(
          Terminal,
          {
            onFormChange: this.handleFormChange,
            paymentMethod: this.props.paymentMethod,
            isSaveCard: this.props.isSaveCard,
            vaultedCard: this.props.vaultedCard,
            vaultedEcheck: this.props.vaultedEcheck
          }
        )
      ] });
    }
  }
}
App.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  isSelfLoaded: PropTypes.bool,
  isEnabledForVTerm: PropTypes.bool,
  isApiUser: PropTypes.bool,
  isMerchantListLoaded: PropTypes.bool,
  merchantList: PropTypes.array,
  isTerminalListLoaded: PropTypes.bool,
  simpleLoginKey: PropTypes.string,
  refresh: PropTypes.func.isRequired,
  simpleLogin: PropTypes.func.isRequired,
  setupListeners: PropTypes.func.isRequired,
  paymentMethod: PropTypes.string.isRequired,
  isSaveCard: PropTypes.bool,
  isActionCompleted: PropTypes.bool,
  actionResult: PropTypes.string,
  cssFile: PropTypes.string,
  customerRef: PropTypes.string,
  getCustomerCards: PropTypes.func.isRequired,
  getCustomerEchecks: PropTypes.func.isRequired,
  vaultedCard: PropTypes.any,
  vaultedEcheck: PropTypes.any
};
function mapStateToProps({ login, app, merchant, terminal, customerVault, self }) {
  return {
    isLoggedIn: login.isLoggedIn,
    isSelfLoaded: self.isSelfLoaded,
    isEnabledForVTerm: self.isEnabledForVTerm,
    isApiUser: self.isApiUser,
    isMerchantListLoaded: merchant.isMerchantListLoaded,
    merchantList: merchant.merchantList,
    isTerminalListLoaded: terminal.isTerminalListLoaded,
    simpleLoginKey: app.simpleLogin,
    paymentMethod: app.paymentMethod,
    isSaveCard: _.get(app, "settings.uiOptions.saveCard"),
    cssFile: _.get(app, "settings.uiOptions.css"),
    customerRef: _.get(app, "settings.data.customer.customerRef"),
    isActionCompleted: app.isActionCompleted,
    actionResult: app.actionResultMessage,
    vaultedCard: customerVault.card,
    vaultedEcheck: customerVault.echeck
  };
}
export default connect(
  mapStateToProps,
  {
    refresh: loginActions.refresh,
    simpleLogin: loginActions.simpleLogin,
    setupListeners: appActions.setupListeners,
    getCustomerCards: customerVaultActions.getCustomerCards,
    getCustomerEchecks: customerVaultActions.getCustomerEchecks
  }
)(App);
